export interface WhWordData {
  word: string;
  partOfSpeech: string;
  french: string;
  pronunciation: string;
  examples: {
    english: string;
    french: string;
    positiveResponse: {
      english: string;
      french: string;
    };
    negativeResponse: {
      english: string;
      french: string;
    };
  }[];
}

export const whWordsData: WhWordData[] = [
  {
    word: "Who",
    partOfSpeech: "Interrogative pronoun",
    french: "Qui",
    pronunciation: "/huː/",
    examples: [
      {
        english: "Who is your best friend?",
        french: "Qui est ton meilleur ami ?",
        positiveResponse: {
          english: "My best friend is Sarah.",
          french: "Mon meilleur ami est Sarah."
        },
        negativeResponse: {
          english: "I don't have a best friend.",
          french: "Je n'ai pas de meilleur ami."
        }
      },
      {
        english: "Who likes chocolate in your family?",
        french: "Qui aime le chocolat dans ta famille ?",
        positiveResponse: {
          english: "My sister likes chocolate.",
          french: "Ma sœur aime le chocolat."
        },
        negativeResponse: {
          english: "Nobody likes chocolate in my family.",
          french: "Personne n'aime le chocolat dans ma famille."
        }
      }
    ]
  },
  {
    word: "What",
    partOfSpeech: "Interrogative pronoun",
    french: "Qu'est-ce que / Quoi",
    pronunciation: "/wɒt/",
    examples: [
      {
        english: "What do you do every morning?",
        french: "Qu'est-ce que tu fais chaque matin ?",
        positiveResponse: {
          english: "I brush my teeth and have breakfast.",
          french: "Je me brosse les dents et je prends le petit-déjeuner."
        },
        negativeResponse: {
          english: "I don't do anything special.",
          french: "Je ne fais rien de spécial."
        }
      },
      {
        english: "What is your favorite hobby?",
        french: "Quel est ton passe-temps préféré ?",
        positiveResponse: {
          english: "My favorite hobby is reading.",
          french: "Mon passe-temps préféré est la lecture."
        },
        negativeResponse: {
          english: "I don't have a favorite hobby.",
          french: "Je n'ai pas de passe-temps préféré."
        }
      }
    ]
  },
  {
    word: "Where",
    partOfSpeech: "Interrogative adverb",
    french: "Où",
    pronunciation: "/weə/",
    examples: [
      {
        english: "Where do you live?",
        french: "Où habites-tu ?",
        positiveResponse: {
          english: "I live in Paris.",
          french: "J'habite à Paris."
        },
        negativeResponse: {
          english: "I don't live anywhere specific.",
          french: "Je n'habite nulle part en particulier."
        }
      },
      {
        english: "Where does your family go on vacation?",
        french: "Où va ta famille en vacances ?",
        positiveResponse: {
          english: "My family goes to the beach.",
          french: "Ma famille va à la plage."
        },
        negativeResponse: {
          english: "My family doesn't go on vacation.",
          french: "Ma famille ne part pas en vacances."
        }
      }
    ]
  },
  {
    word: "When",
    partOfSpeech: "Interrogative adverb",
    french: "Quand",
    pronunciation: "/wen/",
    examples: [
      {
        english: "When do you wake up?",
        french: "Quand te réveilles-tu ?",
        positiveResponse: {
          english: "I wake up at 7 o'clock.",
          french: "Je me réveille à 7 heures."
        },
        negativeResponse: {
          english: "I don't wake up at a specific time.",
          french: "Je ne me réveille pas à une heure précise."
        }
      },
      {
        english: "When is your birthday?",
        french: "Quand est ton anniversaire ?",
        positiveResponse: {
          english: "My birthday is in June.",
          french: "Mon anniversaire est en juin."
        },
        negativeResponse: {
          english: "I don't celebrate my birthday.",
          french: "Je ne fête pas mon anniversaire."
        }
      }
    ]
  },
  {
    word: "Why",
    partOfSpeech: "Interrogative adverb",
    french: "Pourquoi",
    pronunciation: "/waɪ/",
    examples: [
      {
        english: "Why do you like music?",
        french: "Pourquoi aimes-tu la musique ?",
        positiveResponse: {
          english: "I like music because it makes me happy.",
          french: "J'aime la musique parce qu'elle me rend heureux."
        },
        negativeResponse: {
          english: "I don't really like music.",
          french: "Je n'aime pas vraiment la musique."
        }
      },
      {
        english: "Why does your family eat dinner together?",
        french: "Pourquoi ta famille dîne-t-elle ensemble ?",
        positiveResponse: {
          english: "We eat together because we enjoy talking.",
          french: "Nous mangeons ensemble parce que nous aimons discuter."
        },
        negativeResponse: {
          english: "We don't eat dinner together.",
          french: "Nous ne dînons pas ensemble."
        }
      }
    ]
  },
  {
    word: "Which",
    partOfSpeech: "Interrogative determiner",
    french: "Quel / Quelle / Lequel",
    pronunciation: "/wɪtʃ/",
    examples: [
      {
        english: "Which sport do you prefer?",
        french: "Quel sport préfères-tu ?",
        positiveResponse: {
          english: "I prefer football.",
          french: "Je préfère le football."
        },
        negativeResponse: {
          english: "I don't like any sports.",
          french: "Je n'aime aucun sport."
        }
      },
      {
        english: "Which member of your family is the funniest?",
        french: "Quel membre de ta famille est le plus drôle ?",
        positiveResponse: {
          english: "My brother is the funniest.",
          french: "Mon frère est le plus drôle."
        },
        negativeResponse: {
          english: "Nobody in my family is funny.",
          french: "Personne dans ma famille n'est drôle."
        }
      }
    ]
  },
  {
    word: "Whose",
    partOfSpeech: "Interrogative possessive",
    french: "À qui / De qui",
    pronunciation: "/huːz/",
    examples: [
      {
        english: "Whose book is this?",
        french: "À qui est ce livre ?",
        positiveResponse: {
          english: "This is my sister's book.",
          french: "C'est le livre de ma sœur."
        },
        negativeResponse: {
          english: "This book doesn't belong to anyone.",
          french: "Ce livre n'appartient à personne."
        }
      },
      {
        english: "Whose idea was it to have a family dinner?",
        french: "À qui était l'idée d'avoir un dîner de famille ?",
        positiveResponse: {
          english: "It was my mother's idea.",
          french: "C'était l'idée de ma mère."
        },
        negativeResponse: {
          english: "It wasn't anyone's specific idea.",
          french: "Ce n'était l'idée de personne en particulier."
        }
      }
    ]
  }
];

export const taskBasedExercises = {
  fillInTheBlanks: [
    {
      question: "_____ is your favorite family member?",
      answer: "Who",
      french: "_____ est ton membre de famille préféré ?"
    },
    {
      question: "_____ do you usually have for breakfast?",
      answer: "What",
      french: "_____ prends-tu habituellement au petit-déjeuner ?"
    },
    {
      question: "_____ do you go to school?",
      answer: "Where",
      french: "_____ vas-tu à l'école ?"
    },
    {
      question: "_____ do you do your homework?",
      answer: "When",
      french: "_____ fais-tu tes devoirs ?"
    },
    {
      question: "_____ do you like spending time with your family?",
      answer: "Why",
      french: "_____ aimes-tu passer du temps avec ta famille ?"
    }
  ],
  multipleChoice: [
    {
      question: "_____ color do you prefer, blue or red?",
      options: ["What", "Which", "Where", "Who"],
      answer: "Which",
      french: "_____ couleur préfères-tu, bleu ou rouge ?"
    },
    {
      question: "_____ lives in your house?",
      options: ["Who", "What", "Where", "When"],
      answer: "Who",
      french: "_____ habite dans ta maison ?"
    },
    {
      question: "_____ do you feel happy?",
      options: ["When", "Where", "What", "Who"],
      answer: "When",
      french: "_____ te sens-tu heureux ?"
    }
  ],
  matching: [
    {
      english: "Who is your teacher?",
      french: "Qui est ton professeur ?",
      whWord: "Who"
    },
    {
      english: "What time is it?",
      french: "Quelle heure est-il ?",
      whWord: "What"
    },
    {
      english: "Where is the library?",
      french: "Où est la bibliothèque ?",
      whWord: "Where"
    },
    {
      english: "When is lunch?",
      french: "Quand est le déjeuner ?",
      whWord: "When"
    },
    {
      english: "Why are you studying?",
      french: "Pourquoi étudies-tu ?",
      whWord: "Why"
    }
  ]
};